




















import {Vue, Component} from 'vue-property-decorator'
import Footers from '@/components/Footers.vue'

@Component({
  name: 'MemberHasDetach',
  components: {Footers}
})
export default class MemberHasDetach extends Vue {
  private onClickClose(){
    window.close();
  }
}
